import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {editGame, getGameInstance} from "../../actions/game-instance-actions";
import GameForm from "./game-form";
import * as resource from "../../actions/resources";
import {handleApiResponse, types, updateResource} from "../../../../common/crud-actions";
import {setNotification} from "../../actions/notifications-actions";
import {parsePropertiesErrors} from "../../../../common/form-helpers";
import {withRouter} from "react-router-dom";

class GameEdit extends React.Component {

    componentWillMount() {
        const instanceId = this.props.match.params.id;
        this.props.getGameInstance(instanceId);
    }

    editGame = (values, form) => {
        let promise = this.props.updateResource(resource.NAMESPACE_GAME, resource.MODEL_GAME, { id: this.props.match.params.id, resource: values });
        handleApiResponse(
            resource.MODEL_GAME,
            types.ACTION_UPDATE,
            promise,
            (result) => {
                this.props.setNotification('success','Hra úspěšne změnena.');
            },
            (result) => {
                this.props.setNotification('warning','Nepodařilo se upravit hru.');
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'game.properties');
                errors = parsePropertiesErrors(errors, 'user.properties');

                form.setErrors(errors);
                form.setFieldValue('user.password','', false);
                form.setFieldValue('user.password_confirmation','', false);
            },
            (error) => {
                this.props.setNotification('danger','Vyskytla se neočekávaná chyba.');
                console.log(error);
            }
        ).then(() => { form.setSubmitting(false); })
    };

    render() {
        let formInstance = this.props.gameInstance.instance ? {
            game: this.props.gameInstance.instance.data,
            user: this.props.gameInstance.instance.data.user,
            game_definition_id: this.props.gameInstance.instance.data.game_definition.id
        } : undefined;

        return (
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-10 offset-lg-1'>
                        <h1 className='page-title-minor separate-bottom'>Nastavení hry</h1>
                        { formInstance && <GameForm model='forms.gameEdit' instance={formInstance} handleSubmit={this.editGame}/> }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getGameInstance: getGameInstance,
        updateResource: updateResource,
        setNotification: setNotification,
        editGame: editGame
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(GameEdit));
